<template lang="pug">
.scheduling-content
  .scheduling-content-header
    h3.inner-header Reminders
    aiq-button.button-add-new-item.right-top(size="small" @click="scheduleReminder")
      i.el-icon-plus
  .inline-intro Add, edit, or delete reminders for this conversation.
  .scheduling-content-body
    .schedule-item-container(v-for="schedule in schedules")
      .left-color-block
      .center-content-block
        p Reminder: {{ schedule.title }}
        p.time-block will notify you @ {{ formatRecurrenceText(schedule) }}
      .right-icon-container-block(@click="onEditSchedule(schedule)")
        i.el-icon-edit
</template>

<script>
import dayjs from '@/localPlugins/dayjs';
import pick from 'lodash/pick';
import isNil from 'lodash/isNil';
import { SCHEDULE_TYPE } from '@/constants/analytics';
import { RRule } from 'rrule';
import { convertAIQPayloadToRRulePayload } from '@/libs/recurrence';

export default {
  name: 'remindersList',
  props: {
    customer: {
      type: Object,
      required: true,
    },
    schedules: {
      type: Array,
      required: true,
    },
  },
  methods: {
    format(time) {
      return dayjs().isSame(dayjs(time), 'day') ? dayjs(time).calendar() : dayjs(time).format('lll');
    },

    scheduleReminder() {
      this.$store.dispatch('agent/changeDialogVisibility', {
        name: 'schedulesDialog',
        visible: true,
        type: SCHEDULE_TYPE.NOTES,
        data: {
          event_type: 'reminder',
          customer_id: this.customer.id,
          event_data: {
            customer: pick(this.customer, ['id', 'profile']),
          },
        },
      });
    },

    onEditSchedule(schedule) {
      this.$store.dispatch('agent/changeDialogVisibility', {
        name: 'schedulesDialog',
        visible: true,
        data: schedule,
      });
    },

    formatRecurrenceText(schedule) {
      if (!schedule) {
        return '';
      }

      if (isNil(schedule.recurrence)) {
        return this.$filters.formatTime(schedule.execute_at);
      }

      const localTimeOffset = new Date().getTimezoneOffset();
      const rule = new RRule(convertAIQPayloadToRRulePayload(schedule.recurrence, localTimeOffset));

      return rule.toText();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../../../../styles/aiq-variables.scss";

.inner-header {
  padding: 10px 0;
  color: #566682;
  font-size: 14px;
  line-height: 14px;
  font-weight: 300;
}

.scheduling-content {
  .scheduling-content-header {
    position: relative;
  }
}

.schedule-item-container {
  border: 1px dashed #5e718a;
  margin: 5px 0px 5px 0px;
  position: relative;
  min-height: 46px;
  display: block;
  clear: both;
  border-radius: 2px;
  color: #324057;

  .left-color-block {
    float: left;
    width: 4px;
    height: 100%;
    position: absolute;
    background: rgba(70, 112, 179, 1);
  }

  .center-content-block {
    padding: 5px 20px 5px 9px;
    height: calc(100% - 10px);

    .time-block {
      font-size: 10px;
    }
  }

  .right-icon-container-block {
    position: absolute;
    top: 5px;
    right: 10px;
    color: #BFCBD9;
    font-size: 10px;
    cursor: pointer;
  }
}

.right-top {
  position: absolute;
  right: 5px;
  top: 5px;
}

.inline-intro {
    padding-bottom: 0.5rem;
    color: #5e718a;
    font-size: 0.75rem;
    font-weight: 200;
    line-height: 0.9375rem;
}
</style>
